/**
 * Things said on a call that the app handles itself and never sends to the agent. Only whole utterances
 * count ("stop", not "stop the Nike invoice"), so a real request is never swallowed.
 */
export type VoiceIntent = 'stop' | 'hangup' | 'repeat'

const PATTERNS: [VoiceIntent, RegExp][] = [
    ['stop', /^(?:(?:ok(?:ay)?|no|wait|hey) )?(?:stop(?: it| that| please)?|cancel(?: it| that)?|never ?mind|hold on stop)$/],
    ['hangup', /^(?:ok(?:ay)? )?(?:hang up|end (?:the |this )?call|goodbye|good bye|bye(?: bye)?|that'?s all(?: thanks| thank you)?|that'?s it(?: thanks| thank you)?)$/],
    ['repeat', /^(?:sorry )?(?:say that again|can you say that again|repeat that|repeat|what did you say|come again|pardon(?: me)?|sorry what|what)$/],
]

export function matchIntent(text: string): VoiceIntent | null {
    const t = text
        .toLowerCase()
        .replace(/[’]/g, "'")
        .replace(/[^\p{L}\p{N}' ]+/gu, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/ please$/, '')
    if (!t) return null
    for (const [intent, re] of PATTERNS) if (re.test(t)) return intent
    return null
}
